import { ReactElement } from "react";
import { useLocation } from "react-router-dom";

import { Stack } from "@mui/system";
import { LinkIcon } from "@phosphor-icons/react/dist/csr/Link";
import { IfPermission, IntegrationEditor, IntegrationList, IntegrationTypeSelector } from "../../components";
import { FormComponent } from "../../components/common/Form";
import { DefaultPanel, PanelListDetail } from "../../components/ui/panels";
import Permissions from "../../constants/permissions";
import { getQueryParams } from "../../lib/Util";

const IntegrationBrowser = () => {
  const location = useLocation();
  const { mode, type, id } = getQueryParams(location.search);

  let mainContent: ReactElement | null = null;
  if (id) {
    mainContent = <IntegrationEditor.Existing id={id} />;
  } else if (mode === "add" && type) {
    mainContent = <IntegrationEditor.New type={type} />;
  } else if (mode === "add") {
    mainContent = <IntegrationTypeSelector />;
  } else if (mode === "connect" && type) {
    mainContent = <IntegrationEditor.Connect type={type} />;
  }

  return (
    <PanelListDetail.Container>
      <PanelListDetail.ColLHS>
        <DefaultPanel.Container>
          <DefaultPanel.Header>
            <Stack direction={"row"} sx={{ gap: "5px" }}>
              <LinkIcon size={24} weight="bold" data-cy="integrations-icon" /> Integrations
            </Stack>
            <IfPermission permission={Permissions.ManageIntegrations}>
              <PanelListDetail.PullRight>
                <FormComponent.AddButton id="addIntegrationButton" url="integrations" label="Integration" />
              </PanelListDetail.PullRight>
            </IfPermission>
          </DefaultPanel.Header>
          <DefaultPanel.Body>
            <IntegrationList selected={id} />
          </DefaultPanel.Body>
        </DefaultPanel.Container>
      </PanelListDetail.ColLHS>
      <PanelListDetail.ColRHS>{mainContent}</PanelListDetail.ColRHS>
    </PanelListDetail.Container>
  );
};

export { IntegrationBrowser };
